/* ---------------------------------------------------------------------------------------------------------------
   MJP - PAGINA CONTATTI: stato aperto / chiuso
   ---------------------------------------------------------------------------------------------------------------
   Riempie le pastiglie stampate da snippets/mjp-contact-schedule.liquid.

   L'ora e' sempre quella di Roma, non quella del visitatore: un cliente a Londra alle 9:00 deve leggere "aperto",
   perche' a Lecce sono le 10:00. E si calcola qui e non in Liquid perche' la pagina puo' arrivare dalla cache, e un
   "aperto" stampato dal server alle 12:25 sarebbe falso alle 12:40.

   Se un orario non si lascia leggere, la pastiglia resta nascosta: mai un "aperto" costruito su un dato rotto.
   --------------------------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  var ZONE = 'Europe/Rome';
  var WEEKDAY = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  function toMinutes(value) {
    var match = /^(\d{2}):(\d{2})$/.exec(value || '');
    if (!match) return null;
    var h = parseInt(match[1], 10);
    var m = parseInt(match[2], 10);
    if (h > 23 || m > 59) return null;
    return h * 60 + m;
  }

  /* Giorno della settimana (1 = lunedi') e minuti trascorsi dalla mezzanotte, a Roma. */
  function romeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: ZONE,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());

      var out = {};
      for (var i = 0; i < parts.length; i++) out[parts[i].type] = parts[i].value;

      var day = WEEKDAY[out.weekday];
      var hour = parseInt(out.hour, 10) % 24; /* alcuni motori scrivono "24" per la mezzanotte */
      var minute = parseInt(out.minute, 10);

      if (!day || isNaN(hour) || isNaN(minute)) return null;
      return { day: day, minutes: hour * 60 + minute };
    } catch (e) {
      /* Browser senza supporto ai fusi orari: meglio nessuna pastiglia che un orario sbagliato. */
      return null;
    }
  }

  function inRange(day, from, to) {
    return from <= to ? day >= from && day <= to : day >= from || day <= to;
  }

  function stateFor(now, from, to, open, close) {
    var todayOpen = inRange(now.day, from, to);

    if (todayOpen && now.minutes >= open && now.minutes < close) return { open: true };

    if (todayOpen && now.minutes < open) return { open: false, when: 'today' };

    for (var i = 1; i <= 7; i++) {
      var next = ((now.day - 1 + i) % 7) + 1;
      if (inRange(next, from, to)) return { open: false, when: i === 1 ? 'tomorrow' : 'day', day: next };
    }

    return null;
  }

  function format(minutes) {
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
  }

  function render(root) {
    var now = romeNow();
    var pills = root.querySelectorAll('[data-mjp-schedule]');
    var t = root.dataset;
    var days = (t.tDays || '').split(',');

    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];
      var from = parseInt(pill.getAttribute('data-from'), 10);
      var to = parseInt(pill.getAttribute('data-to'), 10);
      var open = toMinutes(pill.getAttribute('data-open'));
      var close = toMinutes(pill.getAttribute('data-close'));

      var valid = now && from >= 1 && from <= 7 && to >= 1 && to <= 7 && open !== null && close !== null && close > open;
      var state = valid ? stateFor(now, from, to, open, close) : null;

      if (!state) {
        pill.hidden = true;
        continue;
      }

      var text;

      if (state.open) {
        text = t.tOpen;
      } else {
        var when = state.when === 'today' ? t.tToday : state.when === 'tomorrow' ? t.tTomorrow : days[state.day - 1] || '';
        text = t.tClosed + ' · ' + t.tReopens + ' ' + when + ' ' + t.tAt + ' ' + format(open);
      }

      if (pill.textContent !== text) pill.textContent = text;
      pill.setAttribute('data-state', state.open ? 'open' : 'closed');
      pill.hidden = false;
    }
  }

  function renderAll() {
    var roots = document.querySelectorAll('[data-mjp-contact]');
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();

  /* Si aggiorna ogni minuto, e subito quando si torna sulla scheda dopo averla lasciata in background. */
  setInterval(renderAll, 60000);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) renderAll();
  });

  document.addEventListener('shopify:section:load', renderAll);
})();
